






import { Component, Vue, Prop } from 'vue-property-decorator'
import PagesSideBar from '@/components/PagesSideBar.vue'

@Component<PagesLayout>({
  components: {
    PagesSideBar
  }
})
export default class PagesLayout extends Vue {}
